import { requestIframeStorageAccess } from './iframe-storage.ts';

const COINRACES_PREFIX = 'coinraces-';

function isCoinracesKey(key: string): boolean {
  return key.startsWith(COINRACES_PREFIX);
}

function trySetItem(store: Storage, key: string, value: string): boolean {
  try {
    store.setItem(key, value);
    return store.getItem(key) === value;
  } catch {
    return false;
  }
}

/** After storage access is granted in an iframe, move sessionStorage values to localStorage. */
export async function promotePersistedValuesToLocalStorage(): Promise<void> {
  await requestIframeStorageAccess();

  const keys: string[] = [];
  for (let i = 0; i < sessionStorage.length; i += 1) {
    const key = sessionStorage.key(i);
    if (key && isCoinracesKey(key)) {
      keys.push(key);
    }
  }

  for (const key of keys) {
    const value = sessionStorage.getItem(key);
    if (value && trySetItem(localStorage, key, value)) {
      sessionStorage.removeItem(key);
    }
  }
}
